import React from 'react';
import { HiShieldCheck } from 'react-icons/hi';
import SettingsSection from './SettingsSection';
import NumberInput from '../common/NumberInput';
import Toggle from '../common/Toggle';
import { useSettings } from '../../context/SettingsContext';

const RiskSettings = () => {
  const { settings, updateSettings } = useSettings();
  const { risk } = settings;

  return (
    <SettingsSection title="리스크 관리" icon={HiShieldCheck}>
      {/* 손실 제한 */}
      <div>
        <h4 className="text-sm font-semibold text-gray-300 mb-3">손실 제한</h4>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <NumberInput
            label="손절 비율"
            value={risk.stopLossPercent}
            onChange={(value) => updateSettings('risk', 'stopLossPercent', value)}
            min={0.1}
            max={10}
            step={0.1}
            unit="%"
          />
          <NumberInput
            label="일일 최대 손실 한도"
            value={risk.maxDailyLoss}
            onChange={(value) => updateSettings('risk', 'maxDailyLoss', value)}
            min={0}
            max={10000000}
            step={10000}
            unit="원"
          />
          <NumberInput
            label="일일 최대 손실 비율"
            value={risk.maxDailyLossPercent}
            onChange={(value) => updateSettings('risk', 'maxDailyLossPercent', value)}
            min={0.1}
            max={100}
            step={0.1}
            unit="%"
          />
        </div>
      </div>

      {/* 수익 목표 */}
      <div>
        <h4 className="text-sm font-semibold text-gray-300 mb-3">수익 목표</h4>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <NumberInput
            label="익절 비율"
            value={risk.takeProfitPercent}
            onChange={(value) => updateSettings('risk', 'takeProfitPercent', value)}
            min={0.1}
            max={20}
            step={0.1}
            unit="%"
          />
          <NumberInput
            label="일일 목표 수익"
            value={risk.maxDailyProfit}
            onChange={(value) => updateSettings('risk', 'maxDailyProfit', value)}
            min={0}
            max={10000000}
            step={10000}
            unit="원"
          />
          <div className="sm:col-span-2">
            <Toggle
              label="목표 달성 시 거래 중단"
              checked={risk.stopOnTargetReached}
              onChange={(value) => updateSettings('risk', 'stopOnTargetReached', value)}
            />
          </div>
        </div>
      </div>

      {/* 포지션 제한 */}
      <div>
        <h4 className="text-sm font-semibold text-gray-300 mb-3">포지션 제한</h4>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <NumberInput
            label="최대 포지션 수"
            value={risk.maxPositionSize}
            onChange={(value) => updateSettings('risk', 'maxPositionSize', value)}
            min={1}
            max={50}
            step={1}
            unit="개"
          />
          <NumberInput
            label="1회 최대 거래 금액"
            value={risk.maxTradeAmount}
            onChange={(value) => updateSettings('risk', 'maxTradeAmount', value)}
            min={100000}
            max={100000000}
            step={100000}
            unit="원"
          />
          <NumberInput
            label="최대 레버리지 배율"
            value={risk.maxLeverage}
            onChange={(value) => updateSettings('risk', 'maxLeverage', value)}
            min={1}
            max={10}
            step={1}
            unit="배"
          />
        </div>
      </div>
    </SettingsSection>
  );
};

export default RiskSettings;
